// extracted by mini-css-extract-plugin
export default {"profileIcon":"ProfileIcon_profileIcon__7P69u","name":"ProfileIcon_name__+ynTa"};